import { InjectionToken } from "@angular/core";

export const START_BACKEND_COMMUNICATION = "START_BACKEND_COMMUNICATION";
export const END_BACKEND_COMMUNICATION = "END_BACKEND_COMMUNICATION";
export const RESET_REDUX_STATE = "RESET_REDUX_STATE";
export const START_NAVIGATION = "START_NAVIGATION";
export const END_NAVIGATION = "END_NAVIGATION";
export const CHANGE_NAVIGATION_ENABLED_STATE = "CHANGE_NAVIGATION_ENABLED_STATE";
export const SET_APP_LOCALE = "SET_APP_LOCALE";

/**
 * @type {symbol} Angular DI provider token for core action factory implementations
 */
export const CoreActionFactoryToken: InjectionToken<CoreActionFactory> = new InjectionToken<CoreActionFactory>("core.action.factory");

/**
 * This is a collection of commonly useful actions. These actions will be handled globally with common reducers. You can
 * find those reducers in this module as well. Please, use these common actions and don't create separate actions for
 * the same common purpose over and over again!
 */
export interface CoreActionFactory {
    /**
     * This action should be called before each backend api call, when an asynchronous http communication is about to
     * start. This typically will be handled with a loading mask on the screen.
     */
    startBackendCommunication (): void;

    /**
     * This action is meant to be called when an asynchronous communication process is ended. This way, we can hide the
     * loading mask, that was displayed while we were communicating.
     */
    endBackendCommunication (): void;

    /**
     * This action is meant to reset the whole redux state to the initial state. It is useful for example after logout.
     */
    resetState (): void;

    /**
     * This action should be called before route change starts. This typically will be handled with a loading mask on the screen.
     */
    startNavigation (): void;

    /**
     * This action is meant to be called when a route change ends. This way, we can hide the
     * loading mask, that was displayed when the route change started.
     */
    endNavigation (): void;

    /**
     * This action is meant to be called manually when the form is modified or return default form state. This way,
     * we can add/delete disable menu style or enable/disable links.
     */
    changeNavigationEnabledState (enabled: boolean): void;

    /**
     * We can set the actual locale for the interface using this method.
     * @param locale The new locale for the admin UI.
     */
    setLocale(locale: string): void;
}
